import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { useLocation, matchRoutes } from 'react-router-dom'
import routes from '../routeHierarchy.json'

const routesWithParams = [
  {
    path: '/applications/:env',
  },
  {
    path: '/applications/edit/:id',
  },
  {
    path: '/accounts/edit/:id',
  },
  {
    path: '/applications/:env/create',
  },
  {
    path: '/accounts/duplicate/:selectedAccount',
  },
  {
    path: '/notifications/recent/:accountid',
  },
]

export const SidenavItem = forwardRef((props, ref) => {
  const { as = 'li', children, currentPath, ...rest } = props
  const { pathname } = useLocation()
  const Component = as

  const [{ route }] = matchRoutes(routesWithParams, pathname) || [
    { route: { path: pathname } },
  ]
  const routeArray = routes[currentPath]

  const activeLink = Array.isArray(routeArray)
    ? routeArray.find((r) => r === route.path)
    : false

  return (
    <Component
      className={`dev_dash__sidenav--item ${activeLink ? 'active' : ''}`}
      ref={ref}
      {...rest}
    >
      {children}
    </Component>
  )
})

SidenavItem.displayName = 'SidenavItem'

SidenavItem.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
  currentPath: PropTypes.string,
}
